<template>
    <div class="popup popup-bankProcess" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="bankPopup">
        <div class="bankProcess-content">
            <template v-if="bankTransferInfo.popupBoxType===2">
                <div class="warning">
                    <div class="warning-title">
                        重要提醒：
                    </div>
                    <div class="warning-text">
                        您预订的是<span class="em-text">临近航线</span>，为避免因入账延迟而导致订单取消，<span
                            class="em-text">不建议您使用转账方式进行支付。</span>
                    </div>
                    <div class="warning-text">
                        如您仍需转账，<span
                            class="em-text">请于{{ bankTransferInfo.showFinalPaymentTime }}前</span>完成转账支付并联系在线客服提供支付水单截图以保留预订，<span
                            class="em-text">超时可能引起您的船票订单被取消，</span>皇家加勒比不承担任何赔偿责任。
                    </div>
                </div>
                <div class="popup-split-line"></div>
            </template>
            <div class="bankProcess-m">
                <div class="bankProcess-title">银行转账流程</div>
                <div class="bankProcess-txt">
                    请汇款至以下账户：
                </div>
                <div class="bankProcess-txt" style="margin-bottom: 13px;">
                    账户名：皇家加勒比游轮船务（中国）有限公司<br>
                    银行名：摩根大通银行（中国）有限公司上海分行<br>
                    银行地址：中国上海市浦东新区银城中路501号上海中心48楼，200120<br>
                    （直客）人民币账号：5002032000<br>
                </div>
                <div class="bankProcess-cell">
                    支付方式为银行转账/汇款
                </div>
                <img class="bankProcess-arrow" src="https://resource.rcclchina.com.cn/tui2/icon22_down_arrow.png">
                <div class="bankProcess-cell">
                    请务必备注好您的订单号、姓名
                </div>
                <img class="bankProcess-arrow" src="https://resource.rcclchina.com.cn/tui2/icon22_down_arrow.png">
                <div class="bankProcess-cell">
                    银行转账/汇款成功并与客服确认<br>
                    请务必在完成付款后致电400-820-7293与客服确认
                </div>
                <div class="bankProcess-cell" style="background: white;color: #666;text-align: left;padding-bottom: 0;">
                    特别提醒：
                    <div class="bankProcess-cell-text">
                        1.若您预订的房型为特定主题房（如巧虎主题房），请您通过线上渠道进行订单支付。线下转账需人工入账且时间较长，会导致您的订单没有及时入账而被系统自动取消。
                        <br>2.转账完成后需至少3个工作日进行入账，未完成入账前您无法办理在线值船。
                        <br>3.若公司转账，退款时需提供所需的公司证明及多份英文材料，退款周期较长，敬请谅解。
                    </div>
                </div>
                <div class="btn-confirm" @click="onConfirm">我已阅读并知晓</div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BankPopup",
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        onGoBack: {
            type: Function
        },
        bankTransferInfo: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    watch: {
        isShow(newVal) {
            if (newVal) {
                // 显示弹窗时禁止背景滚动
                document.body.style.overflow = 'hidden'
            } else {
                // 关闭弹窗时恢复背景滚动
                document.body.style.overflow = ''
            }
        }
    },
    methods: {
        onConfirm() {
            this.onGoBack()
        }
    },
    beforeDestroy() {
        // 组件销毁时确保恢复背景滚动
        document.body.style.overflow = ''
    }
}
</script>

<style lang="less" scoped>
#bankPopup.popup {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.56);
    display: block;
    z-index: 10401;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    opacity: 0;
    visibility: hidden;
}
#bankPopup.modal-in {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.56);
    opacity: 1;
    visibility: visible;
    .bankProcess-content {
        transform: scale(1);
    }
}
#bankPopup.modal-out {
    opacity: 0;
    visibility: hidden;
    .bankProcess-content {
        transform: scale(0.8);
    }
}

#bankPopup {

    .bankProcess-content {
        // margin-top: 60px;
        // height: 100%;
        // overflow: scroll;
        // padding-bottom: 60px;
        max-height: 90%;
        overflow-y: auto;
        transform: scale(0.8);    
        transition: all 0.3s ease;
        background-color: #fff;
        border-radius: 10px;
        margin: 0px 19px 0px;
        .warning {
            padding: 14px 14px 11px;
            &-title {
                font-size: 14px;
                color: #FF0000;
                line-height: 20px;
                font-weight: bold;
            }
            &-text {
                font-size: 12px;
                color: #606060;
                line-height: 20px;
                font-weight: bold;
            }
            .em-text {
                color: #FF0000;
            }
        }
        .popup-split-line{      
            height: 1px;
            background: #F3F3F3;
            margin: 0 8px;
        }
        .bankProcess-title{
            font-size: 14px;
            color: #606060;
            line-height: 24px; 
            font-weight: bold;
        }
        .bankProcess-m {
            padding: 11px 14px 13px;
        }
        .bankProcess-txt {
            // padding-bottom: 16px;
            font-size: 12px;
            color: #606060;
            line-height: 22px;
            font-weight: bold;
        }
        .bankProcess-cell {
            width: 100%;
            margin-bottom: 8px;
            padding: 10px 0;
            font-size: 12px;
            line-height: 20px;
            color: #fff;
            text-align: center;
            background: #4A90E2;
            &-text{
                font-size: 10px;
                color: #606060;
                line-height: 17px;
            }
        }
        .bankProcess-arrow {
            display: block;
            width: 18px;
            margin: 0 auto 6px;
        }
        .btn-confirm{
            width: 134px;
            height: 29px;
            background: linear-gradient(105deg, #F8C133 0%, #FBD633 100%);
            border-radius: 5px;
            margin: 0 auto;
            color: #606060;
            font-size: 12px;
            line-height: 29px;
            text-align: center;
            font-weight: bold;
        }
    }
}
</style>

